import ACTIONS from "./actionTypes"

export const setTravelPlan = payload => ({
  type: ACTIONS.SET_TRAVEL_PLAN,
  payload,
})
